// extracted by mini-css-extract-plugin
module.exports = {"container":"NoWearableNeeded_container___iXP_","content":"NoWearableNeeded_content__a0NXb","benefits":"NoWearableNeeded_benefits__9fCqp"};